
// @ts-nocheck
import { useTheme } from "@emotion/react"
import { Typography } from "@mui/material"
import { Box } from "@mui/system"
import Page from "components/Page"

import LogoAreaX from 'assets/images/areax_logo.svg'
import LogoIC from 'assets/images/ic_logo.svg'
import LogoAssicura from 'assets/images/assicura_logo.svg'
import { useEffect } from "react"
import { useHistory } from "react-router"

interface WallLoghiProps {
  next?: string
}
const WallLoghi = ({ next }: WallLoghiProps) => {
  const theme = useTheme()
  const history = useHistory()

  useEffect(() => {
    next && setTimeout(() => {
      history.push(next)
    }, 3000)
  }, [])

  return (
    <Page bg={theme.palette.background.paper}>
      <Box sx={{
        marginTop: '5vh',
        height: '80vh',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-around'
      }} >
        <Typography variant="h5" color={theme.palette.primary.light} sx={{
          paddingInline: '2rem',
          textAlign: 'center',
          paddingBottom: '2rem'
        }}>
          In collaborazione con:
        </Typography>
        <img src={LogoIC} alt="logo innovation center" />

        <Box sx={{ textAlign: 'center', paddingTop: '2rem' }}>
          <img src={LogoAreaX} alt="logo areax" />

          <Box style={{ display: 'flex', flexDirection: 'row', paddingTop: '2rem' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="subtitle2" color={theme.palette.text.primary} sx={{
                paddingInline: '.5rem',
                textAlign: 'center',
              }}>
                Area X è un’iniziativa di
              </Typography>
            </div>
            <div>
              <img src={LogoAssicura} alt="logo intesa san paolo assicura" />
            </div>
          </Box>

        </Box>
      </Box>
    </Page>
  )
}

export default WallLoghi